import { h, Component, Fragment, createRef } from 'preact';
import dataSvg from './../../assets/data.svg';
import globeSvg from './../../assets/globe.svg';
import downloadSvg from './../../assets/download.svg';
import formatService from '../services/format.service';

export default class ReportComponent extends Component {
    constructor() {
        super();
        this.state = {
        };
    }

    getHeaders() {
        // console.log('%cTRACE: getHeaders', 'color: green; font-weight: 900; background: white');
        if (this.props.data && this.props.dataType) {
            return this.props.dataType.columns.map(column =>
                <th>{column.label}</th>
            );
        }
        return [];
    }

    getRows() {
        // console.log('%cTRACE: getRows', 'color: green; font-weight: 900; background: white');
        if (this.props.data?.length > 0 && this.props.dataType) {
            return this.props.data.map(row =>
                <tr>
                    {
                        this.props.dataType.columns.map(column => {
                            const value = formatService.format(row[column.field], column.format);
                            const classes = isNaN(row[column.field]) ? '' : 'numberJustify';
                            return <td class={classes}>{value}</td>;
                        })
                    }
                </tr>
            );
        }
        else if (this.props.data?.length === 0 && this.props.dataType) {
            return <tr><td colspan={this.props.dataType.columns.length}>No Data</td></tr>;
        }
        return [];
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <article class="report">
                    <div class={`report-preview ${this.props.data && this.props.dataType ? 'hide' : ''}`}>
                        <h1>Build <span class="font-light">a Custom Report</span></h1>

                        <ul class="inline-imgs">
                            <li>
                                <div class="circle">
                                    <img src={dataSvg} alt="Data" width="45" />
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <img src={globeSvg} alt="Geography" width="45" />
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <img src={downloadSvg} alt="Year" width="45" />
                                </div>
                            </li>
                        </ul>

                        <p>This tool provides 'one stop' shopping for your economic and demographic data needs, allowing users
                            to quickly download the data they need by selecting the data type, geography, and time period of
                            interest. A number of commonly used data sets are provided, including data describing the ocean and
                            Great Lakes economy (Economics National Ocean Watch), the total economy of coastal areas, American
                            Community Survey, and Demographic Trends data sets. The tool provides users with
                            a preview of their data before downloading their selections.
                        </p>
                    </div>

                    <div class={`results ${this.props.data && this.props.dataType ? '' : 'hide'}`}>
                        <table class="results-table">
                            <thead>
                                <tr>
                                    {
                                        self.getHeaders()
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    self.getRows()
                                }
                            </tbody>
                        </table>
                    </div>
                </article>
            </Fragment>
        );
    }
}
